import BUTTON_AND_DROPDOWN_BLOCKS from '../templates/ButtonAndDropdown/blocks'
import ONLY_BUTTONS_BLOCKS from '../templates/OnlyButtons/blocks'
import ONLY_DROPDOWN from '../templates/OnlyDropdown/blocks'

function getBlocksByType(type) {
  switch (type) {
    case 'button-and-dropdown':
      return { blocks: BUTTON_AND_DROPDOWN_BLOCKS }
    case 'only-buttons':
      return { blocks: ONLY_BUTTONS_BLOCKS }
    case 'only-dropdown':
      return { blocks: ONLY_DROPDOWN }
    default:
      return { blocks: [] }
  }
}

export {
  getBlocksByType,
}
